/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationGroupResponse } from '../../models/fbo-location-group-response';

export interface GetFboLocationGroupDetails$Params {

/**
 * The ID of the FBO location group to retrieve.
 */
  id: number;
}

export function getFboLocationGroupDetails(http: HttpClient, rootUrl: string, params: GetFboLocationGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, getFboLocationGroupDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationGroupResponse>;
    })
  );
}

getFboLocationGroupDetails.PATH = '/api/administration/fbo-locations-groups/{id}';
